export enum TipoDocumento {
  'Cpf' = 1,
  'Rg' = 2,
  'Passaporte' = 3,
  'Cnh' = 4,
  'CertidaoNascimento' = 5
}